import { render, staticRenderFns } from "./PhoneAgentsPage.vue?vue&type=template&id=d2d3ddbe&"
import script from "./PhoneAgentsPage.vue?vue&type=script&lang=js&"
export * from "./PhoneAgentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports